<template>
  <div class="drone" :class="{show: show}">
    <Navbar ref="navbar" class="navdrone" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  name: "Drone",
  components: {
    Navbar
  },
  data: function() {
    return {
      show: false,
      navHeight: 20,
      hot: false,
      oldYOffset: 0,
      hotDisappear: false,
      expand: false
    };
  },
  methods: {
    changeNavbarVisibility: function(showValue) {
      if (this.expand) return;
      this.show = showValue;
    },
    disappearAndHideBar: function() {
      this.$refs.navbar.$el.style.opacity = 0;
      this.changeNavbarVisibility(false);
      window.setTimeout(() => {
        this.$refs.navbar.$el.style.opacity = 1;
        this.hotDisappear = false;
        //time is same as duration for bar hide
      }, 1000);
      this.hotDisappear = true;
    },
    handleScroll: function(e) {
      if (this.hot) return;
      if (window.pageYOffset == 0) {
        this.disappearAndHideBar();
      }

      if (window.pageYOffset < this.navHeight * 2) {
        return;
      }

      var delta;
      if (e.wheelDelta) {
        delta = e.wheelDelta;
      } else {
        delta = -1 * e.deltaY;
      }
      this.changeNavbarVisibility(delta < 0);

      this.changeNavbarVisibility(this.oldYOffset > window.pageYOffset);
      this.oldYOffset = window.pageYOffset;

      window.setTimeout(() => {
        this.hot = false;
      }, 100);
      this.hot = true;
    }
  },
  mounted: function() {
    this.navHeight = this.$refs.navbar.$el.clientHeight;
  },
  created() {
    window.addEventListener("wheel", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("wheel", this.handleScroll);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
.drone {
  z-index: 52;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  transition: transform 1s ease;
  transform: translateY(-100%);
}

.show {
  transform: translateY(0);
}
</style>
